import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import Nav from "@/components/Nav";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Loader2 } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState("pending");
  const [caseId, setCaseId] = useState(null);
  const nav = useNavigate();
  const sessionId = params.get("session_id");

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let attempts = 0;
    const poll = async () => {
      try {
        const r = await api.get(`/payments/status/${sessionId}`);
        setCaseId(r.data.case_id);
        if (r.data.payment_status === "paid") { setStatus("paid"); return; }
        if (attempts++ < 15) setTimeout(poll, 2000);
        else setStatus("timeout");
      } catch { setStatus("error"); }
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-[#FAFBFD]">
      <Nav />
      <div className="max-w-md mx-auto px-4 py-16">
        <Card className="trust-card">
          <CardContent className="p-10 text-center">
            {status === "paid" ? (
              <>
                <div className="w-14 h-14 mx-auto rounded-full bg-emerald-100 text-emerald-700 grid place-items-center mb-4">
                  <CheckCircle2 className="w-7 h-7" />
                </div>
                <h1 className="text-2xl font-bold text-slate-900">Payment received</h1>
                <p className="text-slate-600 mt-2">Drafting your 4 messages now…</p>
                <Button data-testid="payment-success-continue-button" onClick={() => nav(`/case/${caseId}`)} className="mt-6 rounded-full bg-[#1E3A8A] hover:bg-[#1E40AF]">
                  Go to my case
                </Button>
              </>
            ) : status === "error" ? (
              <>
                <h1 className="text-xl font-bold text-slate-900">Something went wrong</h1>
                <p className="text-slate-600 mt-2">Please contact support if you were charged.</p>
              </>
            ) : (
              <>
                <Loader2 className="w-8 h-8 mx-auto text-[#1E3A8A] animate-spin" />
                <p className="mt-3 text-slate-600">Confirming payment…</p>
              </>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
